import type { NotificationStatusFilter } from "@/lib/notification.api";
import { cn } from "@/lib/utils";
import { INBOX_BUCKETS } from "../notification.constants";

export function NotificationInboxSidebar({
  status,
  unread,
  onStatusChange,
}: {
  status: NotificationStatusFilter;
  unread: number;
  onStatusChange: (status: NotificationStatusFilter) => void;
}) {
  return (
    <aside className="rounded-lg border border-border bg-card p-2">
      <div className="border-b border-border px-2 py-2">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-subtle">
          Boîte de réception
        </p>
      </div>
      <div className="mt-2 space-y-1">
        {INBOX_BUCKETS.map((bucket) => {
          const Icon = bucket.icon;
          const active = status === bucket.value;
          return (
            <button
              key={bucket.value}
              type="button"
              onClick={() => onStatusChange(bucket.value)}
              className={cn(
                "flex w-full items-center justify-between rounded-md px-2.5 py-2 text-left text-[12px] transition-colors",
                active
                  ? "bg-brand-gold-dark text-white"
                  : "text-body hover:bg-surface-muted hover:text-foreground",
              )}
            >
              <span className="flex min-w-0 items-center gap-2">
                <Icon size={14} />
                <span className="truncate">{bucket.label}</span>
              </span>
              {bucket.value === "unread" && unread > 0 && (
                <span
                  className={cn(
                    "rounded-full px-1.5 py-0.5 text-[10px] font-semibold tabular-nums",
                    active ? "bg-card/20 text-white" : "bg-brand-gold-light text-brand-gold-dark",
                  )}
                >
                  {unread}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </aside>
  );
}
